module.exports = __webpack_public_path__ + "assets/icon-myTicket.14fa389e.svg";